import Vue from 'vue';
import VueRouter from 'vue-router';
import Store from '../store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/layout'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue'),
    meta: {
      noAuth: true
    }
  },
  {
    path: '/layout',
    name: 'layout',
    component: () => import('../layout.vue'),
    meta: {
      noAuth: true
    },
    children: [
      {
        path: '',
        redirect: 'transport'
      },
      {
        path: 'transport',
        name: 'transport',
        component: () => import(/* webpackChunkName: "transport" */ '../views/transport.vue')
      }, {
        path: 'trace',
        name: 'trace',
        component: () => import(/* webpackChunkName: "trace" */ '../views/trace.vue')
      }, {
        path: 'affairs',
        name: 'affairs',
        component: () => import(/* webpackChunkName: "affairs" */ '../views/affairs.vue')
      }, {
        path: 'feature',
        name: 'feature',
        component: () => import(/* webpackChunkName: "feature" */ '../views/feature.vue')
      }
    ]
  }

];

const router = new VueRouter({
  mode: 'history',
  routes
});

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.noAuth) {
    next();
  } else {
    if (Store.state.token) {
      next();
    } else {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    }
  }
});

export default router;
